//cf.jd.com/pages/viewpage.action?pageId=177379023

const API = window.pageConfig.isBeta
  ? "//beta-api.m.jd.com/api?"
  : "//api.m.jd.com/api?";

const GOODSCATEGORY = [
  { id: -1, name: "不限" },
  { id: 12762, name: "房产" },
  { id: 12763, name: "交通运输" },
  { id: 12764, name: "土地林权" },
  { id: 12766, name: "股权" },
  { id: 12767, name: "债权" },
  { id: 12765, name: "机械设备" },
  { id: 12769, name: "无形资产" },
  { id: 12768, name: "知识产权" },
  { id: 13129, name: "其他资产" },
  { id: 21439, name: "租赁/经营权" },
  { id: 21440, name: "库存物资" },
  // { id: 21745, name: "招标采购" }
];

const GOODSSORT = [
  { down: "8", id: 0, name: "默认排序", up: "8" },
  { down: "7", id: 1, name: "价格排序", up: "6" },
  { down: "5", id: 2, name: "出价次数", up: "4" },
  { down: "3", id: 3, name: "开始时间", up: "0" },
  { down: "9", id: 4, name: "结束时间", up: "2" },
  { down: "11", id: 5, name: "上拍时间", up: "10" },
];

// const GOODSSTATUS = [
//   { id: -1, name: "不限" },
//   { id: 1, name: "进行中" },
//   { id: 0, name: "预告中" },
//   { id: 2, name: "已结束" },
// ];

const GOODSSTATUS = [
  { id: -1, name: "不限" },
  { id: 1, name: "进行中" },
  { id: 0, name: "预告中" },
  { id: 2, name: "已结束" },
  { id: 6, name: "已暂缓" },
  { id: 7, name: "已中止" },
  { id: 5, name: "已撤回" },
];

const RECOMMENDCATEGORY = [
  { id: -1, name: "不限" },
  { id: 12762, name: "房产" },
  { id: 12763, name: "交通运输" },
  { id: 12764, name: "土地林权" },
  { id: 12766, name: "股权" },
  { id: 12767, name: "债权" },
  { id: 12765, name: "机械设备" },
  { id: 12769, name: "无形资产" },
  { id: 12768, name: "知识产权" },
  { id: 13129, name: "其他资产" },
  { id: 21439, name: "租赁/经营权" },
  { id: 21440, name: "库存物资" },
  { id: 21745, name: "招标采购" },
];

const RECOMMENDRANGE = [
  { id: -1, lower: -1, upper: -1, name: "不限" },
  { id: 1, lower: -1, upper: 5000000, name: "500万以下" },
  { id: 2, lower: 5000000, upper: 15000000, name: "500-1500万" },
  { id: 3, lower: 15000000, upper: 25000000, name: "1500-2500万" },
  { id: 4, lower: 25000000, upper: 35000000, name: "2500-3500万" },
  { id: 5, lower: 35000000, upper: 50000000, name: "3500-5000万" },
  { id: 6, lower: 50000000, upper: -1, name: "5000万以上" },
];

const RECOMMENDSTATUS = [
  { id: -1, name: "不限" },
  { id: 1, name: "招商中" },
  { id: 2, name: "招商结束" },
];

const ZICHANORGTABS = [
  { id: 0, name: "标的物" },
  { id: 1, name: "推介" },
  // { id: 3, name: "报价项目"} 报价项目只有有数据才追加
  // { id: 4, name: "处置公告" }, 处置公告只有有数据才追加
];
const HAIGUANANDZFTABS = [
  { id: 0, name: "标的物" },
  { id: 1, name: "推介" },
  // { id: 3, name: "报价项目"} 报价项目只有有数据才追加
  // { id: 4, name: "处置公告" }, 处置公告只有有数据才追加
];
const POCHANORGTABS = [
  { id: 0, name: "标的物" },
  { id: 1, name: "投资人招募", clstag:"pcshop_invest" },
  { id: 2, name: "机构选聘", clstag:"pcshop_institution" },
  { id: 3, name: "公告" },
];

const PROVINCE = [
  { id: -1, name: "全国" },
  { id: 1, name: "北京" },
  { id: 2, name: "上海" },
  { id: 3, name: "天津" },
  { id: 4, name: "重庆" },
  { id: 5, name: "河北" },
  { id: 6, name: "山西" },
  { id: 7, name: "河南" },
  { id: 8, name: "辽宁" },
  { id: 9, name: "吉林" },
  { id: 10, name: "黑龙江" },
  { id: 11, name: "内蒙古" },
  { id: 12, name: "江苏" },
  { id: 13, name: "山东" },
  { id: 14, name: "安徽" },
  { id: 15, name: "浙江" },
  { id: 16, name: "福建" },
  { id: 17, name: "湖北" },
  { id: 18, name: "湖南" },
  { id: 19, name: "广东" },
  { id: 20, name: "广西" },
  { id: 21, name: "江西" },
  { id: 22, name: "四川" },
  { id: 23, name: "海南" },
  { id: 24, name: "贵州" },
  { id: 25, name: "云南" },
  { id: 26, name: "西藏" },
  { id: 27, name: "陕西" },
  { id: 28, name: "甘肃" },
  { id: 29, name: "青海" },
  { id: 30, name: "宁夏" },
  { id: 31, name: "新疆" },
  { id: 52993, name: "港澳" },
  { id: 32, name: "台湾" },
  { id: 84, name: "钓鱼岛" },
];

const LOCATIONLITERAL = {
  EMPTY: {
    value: "",
  },
  PROVINCE: {
    value: "province",
  },
  CITY: {
    value: "city",
  },
  DISTRICT: {
    value: "district",
  },
};

const RECOMMENDSORT = [
  { down: 1, id: 1, name: "默认排序", up: 1 },
  { down: 3, id: 2, name: "参考价值", up: 4 },
];

const MECHANISMSELECTIONSORT = [
  { down: 1, id: 1, name: "发布时间倒序", up: 1 },
  { down: 2, id: 2, name: "发布时间顺序", up: 2 },
  { down: 3, id: 3, name: "申报期限倒序", up: 3 },
  { down: 4, id: 4, name: "申报期限顺序", up: 4 },
];

const MECHANISMSELECTIONSTATUS = [
  { id: -1, name: "不限" },
  { id: 20, name: "公告中" },
  { id: 30, name: "公告结束" },
  { id: 40, name: "公告中止" },
];

const ORGANIZATIONTYPE = [
  { id: 1001, name: "审计机构" },
  { id: 1002, name: "评估机构" },
  { id: 1003, name: "拍卖机构" },
  { id: 1004, name: "其他机构" },
];

//业务线信息
const BUSINESS_INFO = {
  HAIGUANANDZF: {
    code: 6,
    title:"海关政府",
    adAreaId: "20011"
  },
  SIFA: {
    code: 7,
    title:"司法拍卖",
    adAreaId: "30036"
  },
  ZICHAN: {
    code: 9,
    title:"金融资产",
    adAreaId: "40020"
  },
  POCHAN: {
    code: 10,
    title:"破产强请",
    adAreaId: "60022"
  },
}


//获取查询拍品所需apiType参数
const getApiTypeByGetItem=(publishSource:number)=>{
  let apiType = 9
  if(publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
    apiType = 12
  } else if(publishSource==BUSINESS_INFO.SIFA.code){
    apiType = 2
  } else if(publishSource==BUSINESS_INFO.ZICHAN.code){
    apiType = 9
  } else if(publishSource==BUSINESS_INFO.POCHAN.code){
    apiType = 0
  }
  return apiType
}

/**
 * 对公批转状态枚举（text为实际批转状态，label为卡片中要展示的文案）
 */
const tenderStatusConfigEnum = {
  0: { class: '', text: '', label : '' },
  1: { class: 'todo', text: '邀约中', label: '邀约中' },
  2: { class: 'doing', text: '报价中', label: '报价中'},
  3: { class: 'done', text: '待确认招标结果', label: '已结束'},
  4: { class: 'done', text: '成交', label: '已结束'},
  5: { class: 'done', text: '流标', label: '已结束'}
}

/**
* 对公批转状态
*/
const tenderStatusEnum = {
  todo: [1],
  doing: [2],
  done: [3, 4, 5]
}

const ASSET_TYPE = {
  shangYeZiChan: 8, // 商业资产
  jinRongZiChan: 7, // 金融资产
  guoYouZiChan: 1, // 国有资产
  haiGuanFaMo: 11, // 海关罚没
  zhengFuGuoZi: 12, // 政府国资
}

const ASSET_TYPE_NAME = {
  [ASSET_TYPE.shangYeZiChan]: '商业资产',
  [ASSET_TYPE.jinRongZiChan]: '金融资产',
  [ASSET_TYPE.guoYouZiChan]: '海关/政府/国资',
  [ASSET_TYPE.haiGuanFaMo]: '海关/政府/国资',
  [ASSET_TYPE.zhengFuGuoZi]: '海关/政府/国资',
}

export {
  // API,
  GOODSCATEGORY,
  GOODSSORT,
  GOODSSTATUS,
  LOCATIONLITERAL,
  ZICHANORGTABS,
  POCHANORGTABS,
  HAIGUANANDZFTABS,
  PROVINCE,
  RECOMMENDCATEGORY,
  RECOMMENDRANGE,
  RECOMMENDSORT,
  RECOMMENDSTATUS,
  MECHANISMSELECTIONSORT,
  MECHANISMSELECTIONSTATUS,
  ORGANIZATIONTYPE,
  BUSINESS_INFO,
  getApiTypeByGetItem,
  tenderStatusEnum,
  tenderStatusConfigEnum,
  ASSET_TYPE,
  ASSET_TYPE_NAME,
};
